import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { px } from '../../utils';
import { Box } from '../Box';
import { CONTAINER_DESKTOP_MARGIN, CONTAINER_MAX_WIDTH, CONTAINER_MOBILE_MARGIN } from './Container.constants';
const padding = [`0 ${px(CONTAINER_MOBILE_MARGIN)}`, `0 ${px(CONTAINER_DESKTOP_MARGIN)}`];
export const Container = forwardRef(function Container(_ref, ref) {
  let {
    children,
    testId,
    ...boxProps
  } = _ref;
  return React.createElement(Box, _extends({
    ref: ref,
    padding: padding,
    margin: "0 auto"
  }, boxProps, {
    position: "relative",
    width: "100%",
    maxWidth: CONTAINER_MAX_WIDTH,
    testId: testId,
    "data-component": "Container"
  }), children);
});